<template>
    <div v-if="tripadvisorRating">
        <v-divider class="mt-3 mb-2" />
        <tripadvisor-rating :tripadvisor-rating="tripadvisorRating" />
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import TripadvisorRating from '~src/components/hotels/snippets/TripadvisorRating.vue'

    @Component({components: {TripadvisorRating}})
    export class TripadvisorRatingWrapper extends Vue {
        @Prop() tripadvisorRating
    }

    export default TripadvisorRatingWrapper
</script>
